import type { WalletConnectorMetadata } from "@solana/connector/react";

const MOBILE_WALLET_ADAPTER_NAMES = new Set(["mobile wallet adapter", "remote mobile wallet adapter"]);

const MOBILE_USER_AGENT_PATTERN = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

// Same WebView guard used by @solana-mobile/wallet-standard-mobile.
const ANDROID_WEBVIEW_PATTERN =
    /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i;

interface BrowserEnvironment {
    userAgent: string;
    isSecureContext: boolean;
    hasDocument: boolean;
    maxTouchPoints: number;
}

function getBrowserEnvironment(): BrowserEnvironment {
    return {
        userAgent: typeof navigator === "undefined" ? "" : navigator.userAgent,
        isSecureContext: typeof window !== "undefined" ? window.isSecureContext : false,
        hasDocument: typeof document !== "undefined",
        maxTouchPoints: typeof navigator === "undefined" ? 0 : navigator.maxTouchPoints
    };
}

export function isMobileBrowser(): boolean {
    return MOBILE_USER_AGENT_PATTERN.test(getBrowserEnvironment().userAgent);
}

export function isMobileWalletAdapterConnector(connector: Pick<WalletConnectorMetadata, "id" | "name">): boolean {
    const connectorId = connector.id.toLowerCase();
    const connectorName = connector.name.toLowerCase();

    return connectorId.startsWith("mwa:") || MOBILE_WALLET_ADAPTER_NAMES.has(connectorName);
}

export function isMobileWalletAdapterSupportedEnvironment(
    environment: BrowserEnvironment = getBrowserEnvironment()
): boolean {
    const { userAgent, isSecureContext, hasDocument, maxTouchPoints } = environment;

    return (
        hasDocument &&
        isSecureContext &&
        maxTouchPoints > 0 &&
        /android/i.test(userAgent) &&
        !ANDROID_WEBVIEW_PATTERN.test(userAgent)
    );
}
